import React from 'react';
import { motion } from 'framer-motion';
import { Watermark } from './Watermark';
import { LayoutGrid, Briefcase, ShieldCheck, Sparkles, Clock, MapPin } from 'lucide-react';
const benefits = [{
  icon: <LayoutGrid className="w-6 h-6" data-id="element-47" data-mp="4je1zs5yj54p" />,
  title: 'Todo organizado en un solo lugar'
}, {
  icon: <Briefcase className="w-6 h-6" data-id="element-48" data-mp="3vpp9o75h3450" />,
  title: 'Fácil de transportar'
}, {
  icon: <ShieldCheck className="w-6 h-6" data-id="element-49" data-mp="3qrw33d09c847" />,
  title: 'Materiales resistentes'
}, {
  icon: <Sparkles className="w-6 h-6" data-id="element-50" data-mp="3mpixqppfac7y" />,
  title: 'Diseño hermoso y premium'
}, {
  icon: <Clock className="w-6 h-6" data-id="element-51" data-mp="3hqpml3xlyxay" />,
  title: 'Ahorra tiempo al trabajar'
}, {
  icon: <MapPin className="w-6 h-6" data-id="element-52" data-mp="3crutn95xfsd4" />,
  title: 'Perfecto para citas a domicilio o estudio'
}];
export function Benefits() {
  return <section className="relative overflow-hidden py-14 sm:py-20 lg:py-24 px-5 sm:px-6 bg-white" data-id="element-53" data-mp="1fyjibyz0h26s">
      <Watermark position="left" align="top" size={700} opacity={0.05} data-id="element-54" data-mp="1b1jc9o25vzfo" />
      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-55" data-mp="2qog76e8jpdw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-14" data-id="element-56" data-mp="2pwmk14781q9">
          <h2 className="text-3xl md:text-4xl font-serif text-luxury-black mb-4" data-id="element-57" data-mp="lhfo03ikr7q6">
            ¿POR QUÉ LO AMARÁS?
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-58" data-mp="qg8wtimx2ak0"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-59" data-mp="br332a6ulcji">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-nude-light p-8 rounded-xl border border-nude hover:border-gold/30 transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-60" data-mp="gow82zwf00i7" data-mpi={index}>
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center text-gold mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-61" data-mp="155k85wb3dpef">
                {benefit.icon}
              </div>
              <h3 className="text-lg font-sans font-medium text-luxury-black" data-id="element-62" data-mp="qebhdjvgdxzp">
                {benefit.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}